import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "../Inventory/Inventory.css";

export const NewBill = () => {
  const [addStockRow, setAddStockRow] = useState([
    {
      id: 1,
      productCode: "001",
      productName: "",
      uom: "",
      qty: "",
      price: "",
      total: "",
      discount:"",
      final:"",
    },
  ]);
  // Add stock  new row
  const handleAddStockRow = () => {
    setAddStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now(), //it creates a unique ID based on the exact millisecond the row was added.
       productCode: "001",
      productName: "",
      uom: "",
      qty: "",
      price: "",
      total: "",
      discount:"",
      final:"",
      },
    ]);
  };

  // Delete add stock row
  const handleDeleteStockRow = (id) => {
    setAddStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };

  return (
    <div className="inventoryContainer">
      <div className="container">
        <div className="d-flex gap-1 mb-2">
          <span className="me-2">
            <Link to="/state-sales" style={{ color: "black" }}>
              <FaArrowLeftLong />
            </Link>
          </span>
          <div className="addModalTitle">New Bill</div>
        </div>

        {/* Reference No & Date */}
          <div className="bulkAddGrid">
          <div>
            <label>Invoice Number</label>
            <input type="text" placeholder="Enter Invoice Number" />
          </div>
          <div>
            <label>Customer Name</label>
            <input type="text" placeholder="Enter Customer Name" />
          </div>
        </div>
           <div className="bulkAddGrid">
          <div>
            <label>Phone Number</label>
            <input type="text" placeholder="Enter Phone Number" />
          </div>
          <div>
            <label>Payment Method</label>
            <select>
              <option>Payment Method</option>
            </select>
          </div>
        </div>

          <div className="bulkAddGrid">
          <div>
            <label>Address</label>
            <input type="text" placeholder="Enter Address" />
          </div>
          <div>
            <label>City</label>
            <input type="text" placeholder="Enter City" />
          </div>
        </div>
          <div className="bulkAddGrid">
          <div>
            <label>State</label>
            <input type="text" placeholder="Enter State" />
          </div>
          <div>
            <label>GSTIN</label>
            <input type="text" placeholder="Enter GSTIN" />
          </div>
        </div>
        {/* Table */}

        <div className="dashboardTableContainer">
          <TableContainer component={Paper}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead className="dashboadTableHeader">
                <TableRow>
                  <TableCell>Product Code</TableCell>
                  <TableCell align="left">Product Name</TableCell>
          
                  <TableCell align="left">UOM</TableCell>
                  <TableCell align="left">Qty</TableCell>
                  <TableCell align="left">Price/Unit (₹)</TableCell>
                  <TableCell align="left">Total (₹)</TableCell>
                  <TableCell align="left">Discount (%)</TableCell>
                  <TableCell align="left">Final (₹)</TableCell>
                  <TableCell align="left">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {addStockRow.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    className="dashboardTableBody"
                  >
                    <TableCell align="left">
                      <select
                        className="addModalQtySelect"
                        value={row.productCode}
                      >
                        <option value="001">001</option>
                        <option value="002">002</option>
                      </select>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.productName}
                          placeholder="Product"
                        />
                      </span>
                    </TableCell>

                   

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input type="text" value={row.uom} placeholder="UOM" />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input type="text" value={row.qty} placeholder="Qty" />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.price}
                          placeholder="Price"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span>
                    </TableCell>
                     <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.discount}
                          placeholder="Discount"
                        />
                      </span>
                    </TableCell>
                     <TableCell align="left">
                      <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.final}
                          placeholder="Final"
                        />
                      </span>
                    </TableCell>

                    <TableCell align="left">
                      <MdDeleteOutline
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteStockRow(row.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        {/* Add Row Button */}
        <div
          className="addRowText"
          onClick={handleAddStockRow}
          style={{ cursor: "pointer", marginTop: "10px" }}
        >
          + Add Row
        </div>

        {/* Totals */}
        <div className="addModalTotalContainer">
          <div>
            <div className="addModalContent">
              <span>Total Products:</span>
              <span>2400 nos</span>
            </div>
            <div className="addModalContent">
              <span>Subtotal:</span>
              <span>₹9,60,000</span>
            </div>
              <div className="addModalContent">
              <span>Total Discount:</span>
              <span>-₹48,000</span>
            </div>
               <div className="addModalContent">
              <span>Total Value:</span>
              <span>₹9,12,000</span>
            </div>
              <div className="addModalContent">
              <span>Amount Paid:</span>
              <span>₹9,12,000</span>
            </div>
          </div>
        </div>

        {/* Notes */}
         <div className="bulkAddTextGrid">
          <div>
            <label>Additional Notes</label>
          </div>
          <div>
            <textarea placeholder="Type here" rows={4}></textarea>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex justify-content-end">
          <div
            className="addModalButtons"
            style={{ marginTop: "20px", display: "flex", gap: "10px" }}
          >
            <button className="addBtnCancel">Cancel</button>
            <button className="addBtnSave">Generate Invoice</button>
          </div>
        </div>
      </div>
    </div>
  );
};
